import { AuthError } from '@common/interfaces/auth'
import { loginErrorActions } from '../redux/profile/sagas'

// Maps backend AuthError codes to login error page types
interface IErrorWithCode {
  code?: string
}

export const mapErrorToLoginErrorType = (error: IErrorWithCode | null | undefined): string => {
  if (!error) return 'default'

  const { code } = error

  // Only handle specific AuthError enum values
  if (code && (Object.values(AuthError) as string[]).includes(code)) {
    return code
  }

  // For non-AuthError codes, return default
  return 'default'
}

// Determines if an error should redirect to login error page instead of showing snackbar
export const shouldRedirectToLoginError = (
  actionType: string,
  error?: IErrorWithCode | null,
): boolean => {
  const isLoginAction = loginErrorActions.some((action) => actionType.includes(action))

  if (isLoginAction && error?.code && (Object.values(AuthError) as string[]).includes(error.code)) {
    return true
  }

  return false
}
